import React from "react";
import { Icon } from "@iconify/react";
import DataManagement from "../../components/table/DataManagement.jsx";
import { Link } from "react-router-dom";

import { useEventosContingencia } from "../../hooks_cache/useEventoContingencia.js";

const codigoGeneracionColumn = {
  accessorKey: "codigoGeneracion",
  id: "codigoGeneracion",
  header: "Codigo de generacion",
  cell: ({ row }) => {
    const { id, codigoGeneracion } = row.original;
    return (
      <Link to={`/contingencia/${id}`} className="fw-bold text-nowrap">
        {codigoGeneracion}
      </Link>
    );
  },
};

const columns = [
  codigoGeneracionColumn,
  { accessorKey: "fInicio", header: "Fecha Inicio" },
  { accessorKey: "fFin", header: "Fecha final" },
  { accessorKey: "motivoContingencia", header: "Motivo de contingencia" },
  { accessorKey: "estado", header: "estado" },
];

function TercerosTable() {
  const { data: eventosContingenica, refetch } = useEventosContingencia();

  return (
    <DataManagement
      columns={columns}
      data={eventosContingenica}
      title="Gestion de eventos de contingencia"
      actions={[
        <button onClick={refetch} className="btn btn-theme btn-sm d-flex pe-3 rounded-3">
          <Icon className="iconify fs-18px me-2 ms-n1" icon="solar:refresh-bold-duotone" />
          Refrescar tabla
        </button>,
      ]}
    />
  );
}

export default TercerosTable;
